import "./App.scss";
import { router } from "./__product__/navigation/router";
import AppHook from "./AppHook";
function App() {
  AppHook();
  /**
   * render build method
   */
  return router();
}

export default App;
